import { Sparkles } from "lucide-react";

/**
 * Transition banner that bridges the Growth Planner (financial opportunity)
 * into the Pricing section (investment). Reframes the reader's mindset from
 * "cost" to "investment in a system".
 */
export default function PricingBridge() {
  return (
    <section
      data-testid="wc-pricing-bridge"
      className="bg-white pt-20 sm:pt-24 pb-6"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#f3efff] text-[#673dfc] font-nav font-semibold text-xs rounded-full px-3 py-1 mb-5">
          <Sparkles size={13} /> Before you look at the plans
        </div>
        <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-[#30265b]">
          You&apos;re not paying for marketing —{" "}
          <span className="text-[#673dfc]">
            you&apos;re investing in a system.
          </span>
        </h2>
        <p className="mt-6 text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto">
          A system designed to consistently grow your subscriber base and help
          you reach your goal of building a{" "}
          <span className="font-display font-semibold text-[#30265b]">
            $10,000/month recurring income business.
          </span>
        </p>
        <p className="mt-4 text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
          Now, choose the level of support that best fits your growth goals.
        </p>
      </div>
    </section>
  );
}
